import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import {
  InboundOrderDto,
  OrderAttachmentDto,
} from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';

import { saveAs } from 'file-saver';
import { OrderReviewReprovedModalComponent } from '../order-review-reproved-modal/order-review-reproved-modal.component';
import { SuccessModalComponent } from '../../shared/modals/success-modal/success-modal.component';
import { ApproveOrderConfirmComponent } from '../approve-order-confirm/approve-order-confirm.component';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-review-modal',
  templateUrl: './order-review-modal.component.html',
  styleUrls: ['./order-review-modal.component.scss'],
})
export class OrderReviewModalComponent implements OnInit {
  boobleModalData: any;
  currency: any;
  rType: string = '';
  moedas = Moedas;
  loading: boolean;
  orderSituation: boolean;

  constructor(
    private modalService: BoobleModalService,
    private router: Router,
    private readonly ordersService: OrdersService,
    private readonly notifier: NotifierService
  ) {}

  ngOnInit() {
    this.rType = this.router.url.includes('0') ? '0' : '1';
    if (typeof this.boobleModalData === 'number') {
      this.ordersService.getOrderById(this.boobleModalData, "true").subscribe({
        next: (result) => {
          this.loading = false;
          this.boobleModalData = result.data;
          this.currency = this.moedas.find(
            (moeda) => moeda.id === this.boobleModalData.currency?.id
          );
        },
        error: (err) => {
          this.loading = false;
        },
      });
    }
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  downloadAttachment(orderAttachment: OrderAttachmentDto) {
    this.ordersService.downloadOrderAttachment(orderAttachment.id).subscribe({
      next: (data: any) => saveAs(data, orderAttachment.fileName),
    });
  }

  attachmentFileName(fileName: string) {
    return fileName.substring(fileName.lastIndexOf('-') + 1, fileName.length);
  }

  approveOrder() {
    this.boobleModalData.approved = true;
    this.openApproveOrderConfirmModal(this.boobleModalData);
  }

  repproveOrder() {
    this.boobleModalData.approved = false;
    this.openOrderReviewReprovedModal(this.boobleModalData);
  }

  openOrderReviewReprovedModal(order: InboundOrderDto) {
    this.modalService.present(OrderReviewReprovedModalComponent, {
      type: 'repprove',
      order: order,
    });
  }

  cancelOrder(order: any) {
    this.modalService.present(OrderReviewReprovedModalComponent, {
      type: 'cancel',
      order: order,
    });
  }

  openApproveOrderConfirmModal(order: InboundOrderDto) {
    this.modalService.present(ApproveOrderConfirmComponent, order);
  }

  openOrderReviewSuccessModal() {
    this.modalService.present(SuccessModalComponent);
  }
}
